<div class="edit-mobile-no-wrapper">
  <p class="edit-mobile-no-icon">📱</p>
  <h1 class="edit-mobile-no-heading">{{((data?.autoOpen || data?.isSpoofMsn) ? "mobile-number-update.title" : "mobile-number-update.Edit") | translate }}</h1>

  <!-- MSN Update Form  -->
  <ion-grid class="ion-no-padding mobile-input" [formGroup]="phoneNumberForm">
    <ion-row>
      <!-- Dailcode inputfield  -->
      <ion-col size="3.2" class="ion-no-padding">
        <ion-item lines="none" class="ion-input-field">
          <ion-input type="tel" formControlName="dialCode" min="1" maxlength="4" placeholder="+44" class="signupfield"
          (input)="checkInput($event)" (keypress)="getNumericOnly($event)"></ion-input>
          <input id="dialCode" (countryChange)="onCell1CountryChange($event)"
            (intlTelInputObject)="telInputObject($event)" readonly style="display: none;" />
          </ion-item>
        </ion-col>
        <ion-col size="0.3" class="ion-col-gap"></ion-col>
        <ion-col size="8.5" >
          <ion-item
            [ngClass]="phoneInValid ? 'invalid-field' : ''"
            lines="none" class="ion-input-field">
            <input type="tel" placeholder="{{ 'create-account.Your' | translate }}" maxlength="11" inputmode="numeric" accesskey="p"
              (hasError)="phoneNumberHasError($event)" class="signupfield signup-phone-number"
              (input)="getPhoneNumber($event)"
              formControlName="phoneNumber"
              autocomplete="false"
              #phoneNumberInput
              (keypress)="getNumericOnly($event)" />
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>
      <!-- Display  Errors  -->
      <p class="verify-code">{{((data?.autoOpen || data?.isSpoofMsn) ? 'mobile-number-update.verify-reason' : 'mobile-number-update.verification') | translate }}</p>
      @if (phoneNumberForm.get('dialCode')?.invalid && phoneNumberForm.get('dialCode')?.touched) {
        <div class="errorContainer">
          <ion-icon name="warning" class="icon"></ion-icon>
          <span class="text">{{'mobile-number-update.dialCodeRequired' | translate }}</span>
        </div>
      }
      @if (phoneNumberForm.get('phoneNumber')?.errors?.isNumberInvalid || (phoneNumber?.length >= 10 && phoneNumber === data?.phoneNumber)) {
        <div class="errorContainer">
          <ion-icon name="warning" class="icon"></ion-icon>
          @if (phoneInValid && phoneNumber != data?.phoneNumber) {
            <span class="text">{{'mobile-number-update.Please' | translate }}</span>
          }
          @if (phoneNumberForm.get('phoneNumber')?.errors?.isNumberInvalid) {
            <span class="text">{{'mobile-number-update.mobile' | translate }}</span>
          }
          @if (phoneNumber === data?.phoneNumber) {
            <span class="text">{{'mobile-number-update.new' | translate }}</span>
          }
        </div>
      }
      <div id="captcha-container"></div>
      <!-- Update button -->
      <ion-button class="update-number-btn" [disabled]="phoneNumberForm.invalid || isNumberInvalid || phoneNumber === data?.phoneNumber || otpLoader"
        (click)="updateNumber(); startSpinner()">
        @if (!spinnerAnimation && proceed && !otpLoader) {
          <span>{{'mobile-number-update.Update' | translate }}</span>
        }
        @if (!spinnerAnimation && proceed && otpLoader) {
          <span>Please wait...</span>
        }
        @if (spinnerAnimation) {
          <div class="spinners">
            <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40"></mat-progress-spinner>
            <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
            </mat-progress-spinner>
          </div>
        }
        @if (!proceed) {
          <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
        }
      </ion-button>
      @if (!data?.autoOpen) {
        <p class="back-btn" (click)="goBack()"><span class="back-icon">← </span> {{"mobile-number-update.Back" | translate }}
      </p>
    }
  </div>
